import { Center, HStack, Heading, Switch, Tooltip, VStack } from '@chakra-ui/react';
import { atom, useAtom, useAtomValue } from 'jotai';

import { isProd } from '../../../../config';

export const allowOldCarAtom = atom(false);
export const methodFiConnectCalledAtom = atom(false);

const MethodFiDevToolbar = () => {
  const [allowOldCar, setAllowOldCar] = useAtom(allowOldCarAtom);
  const connectCalled = useAtomValue(methodFiConnectCalledAtom);

  if (isProd) return null;

  return (
    <Center>
      <VStack
        align="left"
        borderWidth={2}
        borderColor="grayBlueish"
        borderRadius="lg"
        my="10px"
        p="10px"
        w="300px"
      >
        <Heading size="md" textAlign="center">
          MethodFi Dev Tools
        </Heading>
        <HStack>
          <Tooltip
            label="Cannot change after MethodFi connect call has been made"
            isDisabled={!connectCalled}
            hasArrow
          >
            <Switch
              isChecked={allowOldCar}
              onChange={(e) => setAllowOldCar(e.target.checked)}
              isDisabled={connectCalled}
            >
              Allow Old Car
            </Switch>
          </Tooltip>
        </HStack>
      </VStack>
    </Center>
  );
};

export default MethodFiDevToolbar;
